export default "__VITE_ASSET__BxZPd1RO__"